import Box from "@mui/material/Box";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
// import Tooltip from '@mui/material/Tooltip'
// import AttachmentIcon from '@mui/icons-material/Attachment'
import { Controller, useForm } from "react-hook-form";
import { FORM_VALIDATIONS } from "constants/formValidation";
import messagesService from "services/messages.service";
// import { styled } from '@mui/material/styles'
// import { getImageAsDataUrl } from 'utils/image.util'
import { useEffect, useState } from "react";
import { Avatar } from "@mui/material";
import { stringAvatar } from "utils/avatar.util";
import { getAuthUserId } from "utils/auth.util";
import useQuery from "utils/router.util";
import { getNewConversationId } from "utils/messages.util";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "constants/routes";
import { useAppSelector } from "store/appHooks";
import { StaticDatePicker } from "@mui/x-date-pickers";

// const VisuallyHiddenInput = styled('input')({
//   clip: 'rect(0 0 0 0)',
//   clipPath: 'inset(50%)',
//   height: 1,
//   overflow: 'hidden',
//   position: 'absolute',
//   bottom: 0,
//   left: 0,
//   whiteSpace: 'nowrap',
//   width: 1,
// })

const ChatInput = ({
  convId,
  setHasAttachment,
  conversation,
  filterOutNewConversation,
}: {
  convId: string | null;
  setHasAttachment: any;
  conversation: any;
  filterOutNewConversation: any;
}) => {
  const { control, handleSubmit, reset } = useForm();
  const [attachments, setAttachments] = useState<Array<any>>([]);
  const [timeoutId, setTimeoutId] = useState<any>(null);
  const { userProfile } = useAppSelector((state) => state.userReducer);
  const loggedInAuthId = getAuthUserId();
  const query: any = useQuery();
  const navigate = useNavigate();

  console.log(userProfile);
  useEffect(() => {
    setHasAttachment(attachments.length > 0);
  }, [attachments, setHasAttachment]);

  // const handleImageChange = (e: any) => {
  //   if (e.target.files.length <= 5) {
  //     getImageAsDataUrl(e.target.files, (data: Array<any>) =>
  //       setAttachments((prev: Array<any>) => [
  //         ...data.map((d: any) => ({ ...d })),
  //         ...prev,
  //       ]),
  //     )
  //   }
  // }

  const removeImage = (index: number) => {
    setAttachments((prev) => prev.filter((_: any, i: number) => i !== index));
  };

  const send = async (data: any) => {
    const emailExp = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gim;
    const phoneExp =
      /(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?/gim;

    // replace the email and phone number from message string
    const msg = data.message
      .replace(emailExp, "*********")
      .replace(phoneExp, "##########");

    let finalConvId: any = convId;
    if (finalConvId === "new") {
      finalConvId = await getNewConversationId(
        query.get("fbId")?.toString(),
        query.get("user")?.toString(),
        query.get("img")?.toString(),
        userProfile.image_url
      );
    }

    if (convId === "new") {
      filterOutNewConversation();
      navigate(ROUTES.MESSAGES.replace(":id", finalConvId?.toString()), {
        replace: true,
      });
    }

    await messagesService.addMessage(finalConvId ?? "", {
      text: msg,
    });
    // reset the input value once message get sent
    reset();
    // scroll to the last message
    window.document
      .getElementById("messagingContainer")
      ?.scroll({ top: 100000000, behavior: "smooth" });
  };

  const setTypingStatus = () => {
    if (convId !== "new") {
      messagesService.makeUserStatusTyping(convId, true);
      clearTimeout(timeoutId);
      const id = setTimeout(() => {
        messagesService.makeUserStatusTyping(convId, false);
      }, 2000); // Adjust this value according to your preference (in milliseconds)
      setTimeoutId(id);
    }
  };

  return (
    <form onSubmit={handleSubmit(send)}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          px: "3%",
          py: "1%",
        }}
      >
        <Box width="100%" display="flex" alignItems="center" gap={2}>
          <Controller
            name="message"
            defaultValue=""
            control={control}
            rules={FORM_VALIDATIONS.REQUIRED}
            render={({ field: { onChange, value } }) => (
              <Box width="100%">
                <InputBase
                  onChange={(e) => {
                    onChange(e);
                    setTypingStatus();
                  }}
                  value={value}
                  placeholder="Type your message here..."
                  fullWidth
                  disabled={!convId}
                />
              </Box>
            )}
          />
        </Box>

        <IconButton disabled={!convId} type="submit">
          <img alt="" src="/assets/img/icons/send_message.svg" />
        </IconButton>
      </Box>
    </form>
  );
};

export default ChatInput;
